import { Banner } from '@sunwebgroup/uds-ui/banner'
import { useBreakpoints } from '@sunwebgroup/ui-components/uds'
import React from 'react'
import { useIntl } from '@/intl'
import { CheckoutSection } from '../CheckoutSection'
import styles from './CheckoutWhatNext.module.css'

function CheckoutWhatNext() {
  const intl = useIntl()
  const { isMobile } = useBreakpoints()
  const bannerSize = isMobile ? 'S' : 'M'

  return (
    <CheckoutSection title={intl.formatMessage({ id: 'checkout_steps_what_next_title' })} description={intl.formatMessage({ id: 'checkout_steps_what_next_description' })} glyph="CheckMarkInCircle">
      <div className={styles.banners}>
        <Banner color="neutral" size={bannerSize} hasIcon icon="Envelope">
          <Banner.TextsWrapper>
            <Banner.Text>{intl.formatMessage({ id: 'checkout_steps_what_next_email_title' })}</Banner.Text>
            <Banner.SupportingText>{intl.formatMessage({ id: 'checkout_steps_what_next_email_description' })}</Banner.SupportingText>
          </Banner.TextsWrapper>
        </Banner>

        <Banner color="neutral" size={bannerSize} hasIcon icon="MobilePhone">
          <Banner.TextsWrapper>
            <Banner.Text>{intl.formatMessage({ id: 'checkout_steps_what_next_mobile_phone_title' })}</Banner.Text>
            <Banner.SupportingText>{intl.formatMessage({ id: 'checkout_steps_what_next_mobile_phone_description' })}</Banner.SupportingText>
          </Banner.TextsWrapper>
        </Banner>

        <Banner color="neutral" size={bannerSize} hasIcon icon="Wallet">
          <Banner.TextsWrapper>
            <Banner.Text>{intl.formatMessage({ id: 'checkout_steps_what_next_wallet_title' })}</Banner.Text>
            <Banner.SupportingText>{intl.formatMessage({ id: 'checkout_steps_what_next_wallet_description' })}</Banner.SupportingText>
          </Banner.TextsWrapper>
        </Banner>
      </div>
    </CheckoutSection>
  )
}

export default CheckoutWhatNext
